import React from "react";
import { Grid } from "@material-ui/core";
// import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox, FormControlLabel } from "@material-ui/core";

import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  checkboxContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: "5px",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "left",
    marginRight: "16px",
  },
  checkboxItemFirst: {
    marginLeft: 0,
  },
  "@media only screen and (max-width: 991px)": {
    checkboxContainer: {
      flexDirection: "column",
    },
    checkboxItem: {
      marginBottom: "8px",
      marginRight: 0,
    },
    checkboxItemFirst: {
      marginBottom: "8px",
    },
  },
}));
const InvoiceCheckboxes = ({
  formState,
  setFormState,
  selectedRole,
  disabled,
}) => {
  const classes = useStyles();
  return (

    <div className={classes.checkboxContainer}>
      {disabled &&
        (formState.pO_Based ||
          selectedRole === "TaxTeam" ||
          selectedRole === "Logistic" ||
          selectedRole === "IP" ||
          selectedRole === "Department Coordinator" ||
          selectedRole === "Loam Approver") && (
          // <Grid item xs={12} sm={4} md={4} lg={2} xl={2} pl={1}>
          <div className={classes.checkboxItem}>
            <FormControlLabel
              // style={{ marginLeft: "1px" }}
              style={{ color: "black" }}
              label="Urgent"
              color="secondary"
              control={
                <Checkbox
                  color="secondary"
                  fontSize="small"
                  checked={formState.urgent}
                  onChange={(event) => {
                    setFormState((formState) => ({
                      ...formState,
                      urgent: event.target.checked,
                    }));
                  }}
                  disabled={disabled}
                />
              }
            />
          </div>
          // </Grid>
        )}
      {disabled &&
        (formState.pO_Based ||
          selectedRole === "TaxTeam" ||
          selectedRole === "Logistic" ||
          selectedRole === "IP" ||
          selectedRole === "Loam Approver" ||
          selectedRole === "Department Coordinator") && (
          // <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
          <div className={classes.checkboxItem}>
            <FormControlLabel
              label="Skip Tax Team"
              color="secondary"
              style={{ color: "black" }}
              control={
                <Checkbox
                  color="secondary"
                  fontSize="small"
                  checked={formState.skipTaxStep}
                  onChange={(event) => {
                    setFormState((formState) => ({
                      ...formState,
                      skipTaxStep: event.target.checked,
                    }));
                  }}
                  disabled={disabled || formState.isVPPayment}
                />
              }
            />
          </div>
          // </Grid>
        )}
      {disabled &&
        (formState.pO_Based ||
          selectedRole === "TaxTeam" ||
          selectedRole === "Logistic" ||
          selectedRole === "IP" ||
          selectedRole === "Loam Approver" ||
          selectedRole === "Department Coordinator") && (
          // <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
          <div className={classes.checkboxItem}>
            <FormControlLabel
              label="Logistic Invoices"
              color="secondary"
              style={{ color: "black" }}
              control={
                <Checkbox
                  color="secondary"
                  fontSize="small"
                  checked={formState.isLogistics}
                  onChange={(event) => {
                    setFormState((formState) => ({
                      ...formState,
                      isLogistics: event.target.checked,
                    }));
                  }}
                  disabled={disabled}
                />
              }
            />
          </div>
          // </Grid>
        )}
      {/* <Grid item xs={12} sm={4} md={4} lg={3} xl={3}> */}
      <div className={classes.checkboxItem}>
        <FormControlLabel
          label="Vendor Pre Payment"
          color="secondary"
          style={{ color: "black" }}
          control={
            <Checkbox
              color="secondary"
              fontSize="small"
              checked={formState.isVPPayment}
              onChange={(event) => {
                if (event.target.checked) {
                  setFormState((formState) => ({
                    ...formState,
                    isVPPayment: event.target.checked,
                    isVFPayment: !event.target.checked,
                  }));
                } else {
                  setFormState((formState) => ({
                    ...formState,
                    isVPPayment: event.target.checked,
                  }));
                }
              }}
              disabled={disabled}
            />
          }
        />
      </div>
      {/* </Grid> */}
      {/* <Grid item xs={12} sm={4} md={4} lg={3} xl={3}> */}
      <div className={classes.checkboxItem}>
        <FormControlLabel
          label="Vendor Financing Payment"
          color="secondary"
          style={{ color: "black" }}
          control={
            <Checkbox
              color="secondary"
              fontSize="small"
              checked={formState.isVFPayment}
              onChange={(event) => {
                if (event.target.checked) {
                  setFormState((formState) => ({
                    ...formState,
                    isVFPayment: event.target.checked,
                    isVPPayment: !event.target.checked,
                  }));
                } else {
                  setFormState((formState) => ({
                    ...formState,
                    isVFPayment: event.target.checked,
                  }));
                }
              }}
              disabled={disabled}
            />
          }
        />
      </div>
    </div>
  );
};

export default InvoiceCheckboxes;
